<!-- @format -->

<template>
	<div class="workbench-common-bg">
		<div class="title">
			<span class="workbench-title" @click="handleClick">
				{{ title }}<el-icon style="font-size: 14px"><ArrowRightBold /></el-icon>
			</span>
		</div>
		<div class="content-box">
			<slot></slot>
		</div>
		<div v-if="isWorkbenchedit" class="delEdit">
			<el-icon @click="delEdit"><icon-ant-design:delete-outlined /></el-icon>
		</div>
	</div>
</template>

<script lang="ts" setup>
	const props = defineProps({
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
		title: {
			type: [String],
		},
	});

	const emit = defineEmits(['deletePanelItemEvent', 'handleClickTitle']);

	function delEdit() {
		emit('deletePanelItemEvent', props.id);
	}

	const handleClick = () => {
		emit('handleClickTitle');
	};
</script>

<style lang="scss" scoped>
	.workbench-common-bg {
		background: var(--theme-workbench-background-color);
		height: 100%;
		position: relative;
		padding: 20px;

		.workbench-title {
			font-weight: 600;
			font-family: PingFangSC-Medium;
		}

		.title {
			font-weight: 500;
			font-size: 2rem;
			color: #000000;
			line-height: 30px;

			span {
				cursor: pointer;
			}

			&:hover {
				color: var(--theme-color-primary) !important;
			}
		}

		.content-box {
			height: calc(100% - 30px);
		}

		.delEdit {
			position: absolute;
			top: 10px;
			right: 10px;
			// font-size: $app-fontsize-title;

			.el-icon {
				// color: $theme-workbench-icon-color;
				cursor: pointer;
			}
		}
	}
</style>
